<template>
  <div>
    <v-row justify="center" align="center">
      <v-col cols="12" md="12" sm="12" lg="12">
        <v-banner icon="mdi-alert">Allergen Report</v-banner>
      </v-col>
      <v-col cols="12" sm="12" md="4">
        <v-menu
          v-model="startMenu"
          close-on-content-click
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="startTextField"
              label="From Date"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="startDate"
            :max="max"
            color="green lighten-1"
            header-color="primary"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="12" md="4">
        <v-menu
          v-model="endMenu"
          close-on-content-click
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="endTextField"
              label="To Date"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="endDate"
            :max="max"
            :min="startDate"
            color="green lighten-1"
            header-color="primary"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="12" md="3" lg="4">
        <v-btn
          block
          outlined
          color="blue darken-2"
          :loading="loadingStats"
          @click.stop="getAllergenReport"
        >
          <v-icon class="mr-2">search</v-icon>Find
        </v-btn>
      </v-col>
      <v-col cols="12" sm="12" md="11" lg="12">
        <v-expansion-panels v-if="allergens.length" focusable flat accordion class="mt-2 mb-4">
          <v-expansion-panel v-for="(item,i) in allergens" :key="i">
            <v-expansion-panel-header expand-icon="mdi-menu-down">{{item.group_description}}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-expansion-panels focusable flat accordion class="mt-2 mb-4">
                <v-expansion-panel v-for="(cat,i) in item.categories" :key="i">
                  <v-expansion-panel-header expand-icon="mdi-menu-down">{{cat.category_description}}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-expansion-panels focusable flat accordion class="mt-2 mb-4">
                      <v-expansion-panel v-for="(prod, index) in cat.products" :key="index">
                        <v-expansion-panel-header
                          expand-icon="mdi-menu-down"
                        >{{productNameFormatted(prod)}}</v-expansion-panel-header>
                        <v-expansion-panel-content class="slimContent">
                          <ProductAllergen :product="prod" />
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- <v-card v-if="allergens.length" class="mt-4" flat>
          <v-card-actions>
            <v-btn  v-if="allergens.length" block color="primary" @click.stop="sendCsv">
              <v-icon class="mr-2">email</v-icon>Send Report in CSV
            </v-btn>
          </v-card-actions>
        </v-card>-->

        <v-btn
          v-if="allergens.length"
          block
          color="blue darken-2"
          outlined
          @click.stop="sendCsv"
          :loading="loadingCSV"
        >
          <v-icon class="mr-2">email</v-icon>Send Report in CSV
        </v-btn>
        <span v-if="noData" class="subtile-2 font-weight-medium">No Data found</span>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ProductAllergen from "@/components/product/ProductAllergen.vue";
import moment from "moment";

export default {
  name: "AllergenReport",
  components: { ProductAllergen },
  data: () => {
    return {
      startDate: moment()
        .subtract(28, "days")
        .toISOString()
        .substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      startMenu: false,
      endMenu: false,
      allergens: [],
      noData: false,
      loadingStats: false,
      loadingCSV: false
    };
  },
  computed: {
    ...mapGetters(["retrieveUser"]),

    max() {
      return new Date().toISOString().substr(0, 10);
    },
    startTextField() {
      return moment(this.startDate).format("dddd, MMMM Do YYYY");
    },
    endTextField() {
      return moment(this.endDate).format("dddd, MMMM Do YYYY");
    }
  },
  methods: {
    ...mapActions([
      "fetchAllergenReport",
      "sendAllergenReportCsv",
      "setSnackbar"
    ]),

    productNameFormatted(product) {
      let formattedText = product.description;

      if (product.variety) {
        formattedText += " - ";
        formattedText += product.variety;
      }

      if (product.size) {
        formattedText += " - ";
        formattedText += product.size;
      }

      return formattedText;
    },

    async getAllergenReport() {
      this.loadingStats = true;
      this.allergens = [];

      const rec = {
        userId: this.retrieveUser.userNum,
        sessionKey: this.retrieveUser.sessionKey,
        startTime: this.startDate,
        endTime: this.endDate
      };

      let response = await this.fetchAllergenReport(rec);

      if (response.success == true) {
        this.noData = false;
        this.allergens = Object.values(response.allergens);
        if (this.allergens.length == 0) {
          this.noData = true;
        }
      } else {
        console.log("Error Fetching Allergen Report");
      }

      this.loadingStats = false;
    },

    async sendCsv() {
      this.loadingCSV = true;

      const rec = {
        userId: this.retrieveUser.userNum,
        sessionKey: this.retrieveUser.sessionKey,
        startTime: this.startDate,
        endTime: this.endDate
      };

      let response = await this.sendAllergenReportCsv(rec);

      if (response.success == true) {
        this.setSnackbar({
          text: "Allergen Report Email successfully sent"
        });
      } else {
        this.setSnackbar({ color: "error", text: response.message });
      }

      this.loadingCSV = false;
    }
  }
};
</script>

<style lang="sass" scoped>
.v-expansion-panel
  border: 1px solid rgb(232, 232, 232)

.slimContent .v-expansion-panel-content__wrap
  padding: 0
</style>

